/**
 * @param {jQuery} $ jQuery object.
 */
(function( $ ) {

	/**
	 * Plugin
	 *
	 * @since 1.0.0
	 * @type {object}
	 */
	var self = Astoundify.Plugin || {};

	/**
	 * Bind to the DOM
	 *
	 * @since 1.0.0
	 */
	$(document).ready(function() {

		/**
		 * @todo Make this dynamic.
		 */
		$(document).bind( 'gform_confirmation_loaded', function( e, formId ){
			if ( 7 !== formId ) {
				return;
			}

			var $button = $( '[href="#free-download"]' );

			window.location = $button.data( 'download' );
		} );

	});

})( jQuery );
